module.exports = __webpack_public_path__ + "img/3.4332c975.png";